import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

type FeaturesState = {
  features: Record<string, boolean>
}

const initialState: FeaturesState = {
  features: {}
}

const slice = createSlice({
  name: 'features',
  initialState,
  reducers: {
    setFeatures: (state, action: PayloadAction<Record<string, boolean> | undefined>) => {
      state.features = action.payload ?? {}
    }
  }
})

export const { setFeatures } = slice.actions

export default slice.reducer

export const selectFeatures = (state: RootState) => state.features.features

